export default __webpack_public_path__ + "static/media/refectori-tundra-00.9eca02df.jpg";